
<div class="card" style="margin: 5px !important;">
    <div class="header bg-red">
        <h2>
           Please correct the below mentioned fields ! 
        </h2>
        <a href="javascript:void(0);" (click)="clearBar()" style="position: absolute;right: 15px;">
            <mat-icon aria-hidden="false" class="ml-2" style="margin-top: 2px;margin-left: 110px !important;">close</mat-icon>
          </a>
      </div>
    <div class="body">
        <mat-nav-list>
            <a mat-list-item *ngFor="let field of data; let i = index"style="height: 35px;">
                <span mat-line> <strong>{{ i + 1 }}. {{ field }} </strong>: This is required field.</span>
            </a>
        </mat-nav-list>
    </div>
</div>